<template>
  <m-form
    :title="(isDialog)?null:titile"
    :items="items"
    :cols="cols"
    :show-clear-btn="!isDialog"
    :canSubmit="canSubmit"
    :canDelete="canDelete"
    :is-editing.sync="isEditing"
    :showListBtn="false"
    :show-navigation-btns="false"
    list-export-base-url="reports/lists/warehouse"
    :list_filters="{}"
    :exportParams="{id: item.id}"
    @click:row="setItem"
    @clearForm="clearForm"
    @submit="submit"
    @delete="deleteItem"
  >
    <template #default>
      <v-row>
        <v-col cols="12">
          <v-text-field class="rounded-lg" label=" * نام" v-model="item.name" :disabled="!isEditing" />
        </v-col>
        <v-col cols="12">
          <v-textarea class="rounded-lg" label="توضیحات" v-model="item.explanation" :disabled="!isEditing" />
        </v-col>
        <v-col cols="12" md="12">
          <v-autocomplete
              :menu-props="{ bottom: true, offsetY: true }"
              class="rounded-lg"
              label="انبارگردان ها"
              :items="inventoryClerks"
              v-model="item.inventory_clerk"
              item-text="name"
              item-value="id"
              :disabled="!isEditing"
              multiple
              :return-object="false"
              deletable-chips
              small-chips
          />
        </v-col>

      </v-row>
    </template>
  </m-form>
</template>
<script>
import WareApiMixin from "@/mixin/wareApi";
import { MFormMixin } from "@/components/m-form";

export default {
  mixins: [MFormMixin, WareApiMixin],
  data() {
    return {
      inventoryClerks: [],
      item: {},
      baseUrl: "wares/warehouses",
      permissionBasename: "warehouse",
      cols: [
        {
          text: "نام",
          value: "name",
          type: "text",
          filters: ["name"]
        },
        {
          text: "توضیحات",
          value: "explanation",
          type: "text",
          filters: ["explanation"]
        }
      ]
    };
  },
  props: {
    isDialog: {
      default: false,
    },
  },
    computed: {
    title(){
      return this.setDocumentTitle('تعریف انبار')
    },
    items() {
      return this.warehouses;
    }
  },
  mounted() {
    this.getInventoryClerk()
  },
  methods: {
    getData() {
      this.getWarehouses(true);
    },
    getInventoryClerk() {
      this.request({
        url: this.endpoint(`wares/inventory_clerk/`),
        method: "get",
        success: data => {
          for (let item in data) {
            this.inventoryClerks.push({
              'name': data[item].first_name + ' ' + data[item].last_name,
              'id': data[item].id,
            })
          }

        },
      })
    }
  }
};
</script>